import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=20e3e71e&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3e71e",
  null
  
)

export default component.exports